// LogService.ts
import log from 'loglevel';
import * as Sentry from '@sentry/vue';

class LogService {
    public setup() {
        log.setLevel(log.levels.DEBUG);
        const originalFactory = log.methodFactory;

        log.methodFactory = (methodName, logLevel, loggerName) => {
            const rawMethod = originalFactory(methodName, logLevel, loggerName);

            return (message: any) => {
                rawMethod(message); // Log locally using the original method
                if (methodName === 'error') {
                    this.sendErrorToSentry(message); // Send only errors to Sentry
                }
            };
        };

        log.setLevel(log.getLevel()); // Apply the methodFactory
    }

    private sendErrorToSentry(message: any): void {
        Sentry.captureException(message instanceof Error ? message : new Error(String(message)));
    }
}

// Create a singleton instance of LogService and set it up
const logServiceInstance = new LogService();
export default logServiceInstance;
